import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Dailixinxi"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", { d: "M13.9177 11.5391C16.4997 12.0681 19.5033 13.7908 19.5033 18.7588C19.5033 20.0835 17.7578 20.0835 12.1043 20.0835C6.38039 20.0835 4.70517 20.0835 4.70517 18.7588C4.70517 13.8574 7.70651 12.0703 10.2908 11.5391C8.26648 10.4788 7.56827 8.02923 8.54529 6.04204C9.52231 4.05484 11.966 3.32576 13.8498 4.38604C15.7335 5.44632 16.502 7.89586 15.4547 9.81637C15.1033 10.6121 14.5456 11.1412 13.9177 11.5391Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M8.0767 11.459C8.29694 11.3968 8.35317 11.1256 8.17042 10.9922C6.54909 9.81413 6.05238 7.62243 6.94037 5.81529C7.07157 5.54855 7.22855 5.30404 7.40896 5.08398C7.55891 4.90171 7.40427 4.63719 7.1606 4.6572C6.11096 4.74167 5.11988 5.35516 4.6138 6.38433C3.90623 7.82249 4.2811 9.5585 5.53693 10.5277C5.71031 10.6632 5.65876 10.9255 5.44321 10.99C3.50558 11.5635 1.5 13.0906 1.5 16.6982C1.5 17.2517 1.85847 17.5184 2.84018 17.6495C2.99715 17.6696 3.14242 17.5629 3.15882 17.4117C3.54541 13.6952 5.86494 12.0792 8.0767 11.459V11.459Z"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M15.9233 11.459C15.7031 11.3968 15.6468 11.1256 15.8296 10.9922C17.4509 9.81413 17.9476 7.62243 17.0596 5.81529C16.9284 5.54855 16.7715 5.30404 16.5911 5.08398C16.4411 4.90171 16.5957 4.63719 16.8394 4.6572C17.8891 4.74167 18.8801 5.35516 19.3862 6.38433C20.0938 7.82249 19.7189 9.5585 18.4631 10.5277C18.2897 10.6632 18.3412 10.9255 18.5568 10.99C20.4944 11.5635 22.5 13.0906 22.5 16.6982C22.5 17.2517 22.1415 17.5184 21.1598 17.6495C21.0029 17.6696 20.8576 17.5629 20.8412 17.4117C20.4546 13.6952 18.1351 12.0792 15.9233 11.459V11.459Z"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var dailixinxi = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { dailixinxi as default };
